module.exports = __webpack_public_path__ + "static/media/city_illustration.56ddf36d.svg";